 
/* eslint-disable new-cap */
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';

function SmartPakCancellationBannerViewModel(data) {
    ko.mapping.fromJS(data, {}, this);

    this.hasCancellationMsg = ko.observable(this.IsCancellationIntervention());
    this.horseName = ko.observable(this.HorseName());
    this.email = ko.observable(this.ConfirmationEmail());
    this.stopDate = ko.observable(this.StopAsOfDate());
}

export default SmartPakCancellationBannerViewModel;
